import EmailView from './Email.View';

const Email = () => <EmailView />;

export default Email;
